import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class RoutinesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryRoutinesImpl", void 0);
    _defineProperty(this, "deleteRoutineImpl", void 0);
  }
  async queryRoutines(query) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        routines,
        pagingMetadata
      } = await this.request(this.queryRoutinesImpl({
        query
      }), ...args);
      if (!routines) {
        throw new Error('routines is not an array');
      }
      return {
        items: routines,
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryRoutines', 'Failed to query routines', {
        query
      }, error);
      throw error;
    }
  }
  async deleteRoutine(routineId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.deleteRoutineImpl({
        routineId
      }), ...args);
    } catch (error) {
      this.logError('deleteRoutine', 'Failed to delete routine', {
        routineId
      }, error);
      throw error;
    }
  }
  convertToEntity() {
    throw new Error('convertToEntity is not implemented');
  }
  getServiceNameForLogs() {
    return 'RoutinesClient';
  }
}
//# sourceMappingURL=RoutinesClientBase.js.map